const hasPermission = (user, permission) => {
    if(!user) return false;
    if (user.permissions == null || !Object.keys(user.permissions).includes(permission)) {
       
        return false
    }
    return true;
}

export default hasPermission